import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomeView
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: () => import('../views/About.vue')
  },
  {
    path: '/products',
    name: 'ProductsPage',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/applications',
    name: 'ApplicationsPage',
    component: () => import('../views/Applications.vue')
  },
  {
    path: '/join',
    name: 'JoinPage',
    component: () => import('../views/Join.vue')
  },
  {
    path: '/news',
    name: 'NewsPage',
    component: () => import('../views/News.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 